<div class="wrapper-subscription-plans-page">
  <span class="title-settings-page">Upgrade to {{plan?.role}} plan?</span>
  <div class="wrapper-upgrade-to-plan">
    <div class="wrapper-header-upgrade-plan">
      <button class="custom-btn custom-btn--yellow">
        <span>{{plan?.role}}</span>
      </button>
      <p *ngIf="plan.roleDB === UserRoles.freemium">{{plan.amount}}</p>
      <p *ngIf="plan.roleDB !== UserRoles.freemium"><span>{{plan.amount}} </span>/ month</p>
    </div>
    <div class="wrapper-content-upgrade-plan">
      <div  *ngFor="let offer of plan.offerWhenSinglePlanView" class="wrapper-feature-upgrade-plan">
        <div class="circle-feature-upgrade-plan">
          <img *ngIf="plan.roleDB !== UserRoles.freemium" src="../../../../../assets/icons/outline/icon-check.svg" alt="">
        </div>
        <span>{{offer}}</span>
      </div>
    </div>
    <p class="text-unsubscribe-plan" *ngIf="currentPlan?.cancel_at_period_end && currentPlan?.plan === plan.planId">You will have all features until your subscription ends on  {{ currentPlan?.current_period_end * 1000 | date: 'MMMM d, yyyy' }}</p>
  </div>
  <button *ngIf="currentPlan?.plan !== UserRoles.freemium && !currentPlan?.cancel_at_period_end" (click)="handleSubscription(plan)" class="custom-btn xs-mt-30" [ngClass]="plan.roleDB === UserRoles.freemium ? 'custom-btn--yellow' : 'custom-btn--primary'">
    <span>{{currentPlan?.plan === plan.planId ? plan.btnTextWhenActivePlan : plan.btnTextSinglePlan}}</span>
  </button>
</div>
